
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.972 5.412C14.682 2.377 11.955 0 8.763 0H.999v16h4c.551 0 1-.448 1-1v-3h3a6.01 6.01 0 004.44-1.965 5.951 5.951 0 001.533-4.623z","fill":"#2196F3"}})])
          )
        }
      }
    